import { grays } from '@airwallex/colors';
import { VStack } from '@airwallex/stacks';
import styled from '@emotion/styled';

export const TotalSectionStack = styled(VStack)<{ isTabletOrMobile?: boolean }>`
  margin: 0 16px;
  padding-left: ${({ isTabletOrMobile }) => (isTabletOrMobile ? '8px' : '50%')};
  & p,
  & span {
    font-size: 12px;
  }
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${grays[20]};
`;
